var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v("Create New Database")]),
              _c(
                "gg-card-text",
                [
                  _c("create-database-form", {
                    attrs: {
                      loading: !_vm.restrictionsLoaded
                    },
                    on: {
                      "database-created": _vm.reloadDatabases
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                heading: "Current Databases"
              }
            },
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-md-3",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [_vm._v(" Manage Databases ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "font-weight-regular",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            attrs: {
                              "append-icon": "mdi-magnify",
                              "hide-details": "",
                              placeholder: "Search"
                            },
                            model: {
                              value: _vm.searchDb,
                              callback: function callback($$v) {
                                _vm.searchDb = $$v
                              },
                              expression: "searchDb"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c("databases-table", {
                    attrs: {
                      search: _vm.searchDb,
                      loading: !_vm.databasesLoaded && !_vm.restrictionsLoaded
                    },
                    on: {
                      "table-action-completed": _vm.reloadDatabases
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }